module.exports = __webpack_public_path__ + "media/images/front/products/standard/product_3-89c4fb1ba637c672fa99763bda6ef11a.jpg";